import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  variant?: 'burgundy' | 'black';
  onLinkClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  variant = 'burgundy',
  onLinkClick,
  ...props
}: ButtonProps) {
  const palette = variant === 'black' ? 'bg-ink text-cream-light border-ink hover:bg-black' : 'bg-burgundy text-cream-light border-burgundy-dark hover:bg-burgundy-dark';
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold uppercase tracking-wide rounded-full border-2 ${palette} shadow-[0_6px_0_rgba(26,26,26,0.12)] hover:shadow-[0_8px_24px_rgba(123,30,43,0.25)] transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-cream`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.96
    }} data-id="element-38" data-mp="d2rzgd9pbw87">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.04
  }} whileTap={{
    scale: 0.96
  }} {...props as any} data-id="element-39" data-mp="3qglg30puvayb">
      {children}
    </motion.button>;
}